module.exports = __webpack_public_path__ + "img/bg.e57d8256.jpg";